export const FORM_MODES = {
  VIEW: "VIEW",
  EDIT: "EDIT",
  ADD: "ADD",
};
